import { array, boolean, object } from "superstruct";

import WishlistsSocialShareChannelsSchema from "./WishlistsSocialShareChannelsSchema";

export const WishlistsStorefrontValuesSettingsSchema = object({
    isCopyWishlistEnabled: boolean(),
    isDisabledForGuests: boolean(),
    isSaveWishlistEnabled: boolean(),
    isWishlistDrawerEnabled: boolean(),
    isWishlistSocialShareEnabled: boolean(),
    wishlistSocialShareChannels: array(WishlistsSocialShareChannelsSchema),
});
